import { makePieActionObjs } from "shared/imports/pieActionGenerators"
import { prependAppName } from "shared/imports/sharedHelperFunctions"

const appName = "@@templateManager/"

const patchDownloadTemplate = makePieActionObjs("patch", "downloadTemplate")

export const patchDownloadTemplateActionTypes = prependAppName(appName, patchDownloadTemplate.pieDict)

const actionTypes = prependAppName(appName, {
    ...patchDownloadTemplate.actionTypes,
    CHANGE_DOWNLOAD_TEMPLATE: "CHANGE_DOWNLOAD_TEMPLATE",
})

export default actionTypes
